import useSWR from 'swr';
import { getLanguages, translate } from './translateService';

export function useLanguages() {
	return useSWR('languages', getLanguages, {
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
	});
}

export function useTranslate() {
	const { data, error, isLoading, mutate } = useSWR('translate', null, {
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
	});

	const translateText = async (payload: { text: string; targetLanguage: string }) => {
		const result = await translate(payload);
		await mutate(result, false);
		return result;
	};

	return {
		data,
		error,
		isLoading,
		translateText,
	};
}
